import { CellType } from "@components/spreadsheet/cells";
import { SpreadsheetGrid } from "@components/spreadsheet/SpreadsheetGrid";
import { ColumnDef, SpreadsheetData } from "@components/spreadsheet/types";
import React, { useMemo } from "react";
import { CoaAccountRow, CoaAccountRowError } from "./types";
import styles from "./CoaAccountMapping.module.scss";

interface Props {
    accounts: CoaAccountRow[];
    onAccountsChange: (accounts: CoaAccountRow[]) => void;
    accountErrors?: CoaAccountRowError[];
    hasAttemptedSubmit: boolean;
}

export const CoaImporterSpreadsheet: React.FC<Props> = ({
    accounts,
    onAccountsChange,
    accountErrors,
    hasAttemptedSubmit,
}) => {
    const columns: ColumnDef[] = useMemo(
        () => [
            {
                field: "name",
                label: "Account",
                cellType: CellType.STRING,
                required: true,
                isValid: ({ row }) =>
                    !hasAttemptedSubmit || !accountErrors?.[row]?.name,
            },
            {
                field: "accountClass",
                label: "Classification",
                cellType: CellType.ACCOUNT_CLASS,
                required: true,
                isValid: ({ row }) =>
                    !hasAttemptedSubmit || !accountErrors?.[row]?.accountClass,
            },
        ],
        [accountErrors, hasAttemptedSubmit],
    );

    const handleChange = (newData: SpreadsheetData) => {
        onAccountsChange(
            newData.map((row) => ({
                id: row.id ?? Math.random().toString(),
                name: row.name ?? "",
                accountClass: row.accountClass ?? null,
            })),
        );
    };

    return (
        <SpreadsheetGrid
            stickyHeader
            noOuterBorder
            minSpareRows={20}
            data={accounts}
            columns={columns}
            onChange={handleChange}
            gridTemplateColumns="1fr 220px"
            rowClassName={styles.spreadsheetRow}
            className={styles.spreadsheet}
            rowHoverHighlight
            lightNotEditableCells
            showDropdownIndicator
            overflow="auto"
        />
    );
};
